<template>
  <form id="frm_action" class="available-from">
    <div class="p-formgrid">
      <Toolbar class="fixed-bottom-toolbar div-button available-top-toolbar">
        <template slot="right">
          <Button
              label="Back"
              @click="backToList()"
              id="back"
              class="main-style-button"
          />
        </template>
      </Toolbar>
      <div class="col-6">
        <div class="p-card-field">
          <label class="p-col-fixed txt-right">Type</label>
          <div class="p-col">
            <InputText type="text" class="" v-model="type_name" :disabled="true" placeholder="Input"/>
          </div>
        </div>
        <div class="p-card-field" v-if="mode == 'edit'">
          <label class="p-col-fixed txt-right" :class="`${status=='ST001' ? 'txt-required' : ''}`">Status</label>
          <div class="p-col">
            <v-select :disabled="status != 'ST001'" :clearable="false" :selectable="isStatusSelectable" title="Status" id="available-selectmulti" placeholder="Choose" v-model="selStatus" :options="$constants.AVAILABLE_STATUS[type]" label="label">
              <span slot="no-options" @click="$refs.select.open = false">
                Empty data
              </span>
            </v-select>
            <input class="input_tmp_validator" id="status">
          </div>
        </div>
        <div class="p-card-field" v-if="mode == 'edit'">
          <label class="p-col-fixed txt-right">Property ID</label>
          <div class="p-col">
            <InputText type="text" class="" v-model="property_code" :disabled="true" placeholder="Input"/>
          </div>
        </div>
        <div class="p-card-field">
          <label class="p-col-fixed txt-right">Property</label>
          <div class="p-col">
            <InputText type="text" class="" v-model="property_name" :disabled="true" placeholder="Input"/>
          </div>
        </div>
        <div class="p-card-field">
          <label class="p-col-fixed txt-right">Owner</label>
          <div class="p-col">
            <InputText type="text" class="" v-model="owner_name" :disabled="true"/>
          </div>
        </div>
        <div class="p-card-field">
          <label class="p-col-fixed txt-right">Week</label>
          <div class="p-col">
            <InputText type="text" class="" v-model="week_name" :disabled="true" placeholder="Input"/>
          </div>
        </div>
        <div class="p-card-field" v-if="type == 2 && false">
          <label class="p-col-fixed txt-right" :class="`${status=='ST001' ? 'txt-required' : ''}`">The weeks, the owner wants to exchange with</label>
          <div class="p-col week-expand-zone">
            <v-select :multiple="true" :clearable="true" title="Week" class="" placeholder="Choose" v-model="selWeek" :options="listWeek" >
              <span slot="no-options" @click="$refs.select.open = false">
                Empty data
              </span>
              <template slot="option" slot-scope="option">
                  {{ `Week ${getWeekDate(option.visit_start)} (${getFilterDate(option.visit_start)} - ${getFilterDate(option.visit_end)})`}}
              </template>
              
              <template slot="selected-option" slot-scope="option">
                  {{ `Week ${getWeekDate(option.visit_start)} (${getFilterDate(option.visit_start)} - ${getFilterDate(option.visit_end)})`}}
              </template>
            </v-select>
            <div class="mt-2 d-flex flex-wrap week-chip-list" v-show="selWeek.length > 0">
              <span class="d-flex chip-box m-2 justify-content-between align-items-center" v-for="(item, index) in selWeek" :key="`chip-${index}`">
                <!-- <Chip class="m-2 ml-0" :label="" removable removeIconClass="pi pi-times" @remove="removeChip(index)"/> -->
                <span>{{`Week ${getWeekDate(item.visit_start)} (${getFilterDate(item.visit_start)} - ${getFilterDate(item.visit_end)})`}}</span>
                <span class="clear" @click="removeChip(index)"><i class="pi pi-times"></i></span>
              </span>
            </div>
            <input class="input_tmp_validator" id="week_arr">
          </div>
        </div>
        <div class="p-card-field" v-if="mode == 'edit' && type == 2">
          <label class="p-col-fixed txt-right txt-required">Exchange options</label>
          <div class="p-col">
            <Button label="Add option" icon="pi pi-plus" class="p-button-sm mb-2" @click="openOptionDialog()" :disabled="isCancelledStatus"/>
            <div v-if="listRuleExchange.length < 1" class="text-muted">No exchange option</div>
            <div v-for="(opt, idx) in listRuleExchange" :key="`rule-opt-${idx}`" class="mb-2" style="padding:10px;border:1px solid #d9d9d9;border-radius:6px;">
              <div class="d-flex justify-content-between align-items-start">
                <div>
                  <b>Rule type:</b> {{ getRuleTypeLabel(opt.type_rule) }}
                  <div v-for="(wk, wIdx) in (opt.list_week_change || [])" :key="`opt-week-${idx}-${wIdx}`">
                    {{ formatWeekByMs(wk.visit_start_mi, wk.visit_end_mi) }}
                  </div>
                  <div v-if="(opt.property_ids || []).length > 0" class="mt-1">
                    <b>List of properties:</b>
                    <div class="option-property-chip-list mt-1">
                      <span
                        v-for="(propertyName, pIdx) in getOptionPropertyNames(opt)"
                        :key="`option-property-${idx}-${pIdx}`"
                        class="option-property-chip"
                        :title="propertyName"
                      >
                        {{ propertyName }}
                      </span>
                    </div>
                  </div>
                  <div v-if="opt.type_rule == 2" class="mt-1">Specific properties: {{ (opt.property_ids || []).length }}</div>
                </div>
                <div class="d-flex" style="gap:6px;">
                  <Button label="Edit" icon="pi pi-pencil" class="p-button-sm p-button-outlined" @click="openOptionDialog(idx)" :disabled="isCancelledStatus"/>
                  <Button icon="pi pi-times" class="p-button-sm p-button-danger" @click="removeOption(idx)" :disabled="isCancelledStatus"/>
                </div>
              </div>
            </div>
            <input class="input_tmp_validator" id="rule_arr">
          </div>
        </div>
        <div class="rent-config-grid" v-if="mode == 'edit' && type == 3">
          <div class="rent-config-column">
            <div class="p-card-field">
              <label class="p-col-fixed txt-right" :class="`${status=='ST001' ? 'txt-required' : ''}`">Price per day for owners in the same property</label>
              <div class="p-col">
                <div class="p-inputgroup">
                  <InputNumber id="price" v-model="price" :disabled="status!='ST001'" :minFractionDigits="2" @blur="changePrice($event,'price')"/>
                  <span class="p-inputgroup-addon">EUR</span>
                </div>
              </div>
            </div>

            <div class="p-card-field">
              <label class="p-col-fixed txt-right" :class="`${status=='ST001' ? 'txt-required' : ''}`">Price per day for Five2one members and 3rd party users</label>
              <div class="p-col">
                <div class="p-inputgroup">
                  <InputNumber id="rent_thirdparty_price" v-model="rent_thirdparty_price" :disabled="status!='ST001'" :minFractionDigits="2" @blur="changePrice($event,'rent_thirdparty_price')"/>
                  <span class="p-inputgroup-addon">EUR</span>
                </div>
              </div>
            </div>
            
            <div class="p-card-field">
              <label class="p-col-fixed txt-right">Deposit</label>
              <div class="p-col">
                <div class="p-inputgroup">
                  <InputNumber id="deposit" v-model="deposit" :disabled="status!='ST001'" :minFractionDigits="2"/>
                  <span class="p-inputgroup-addon">EUR</span>
                </div>
              </div>
            </div>
          </div>

          <div class="rent-config-column">
            <div class="p-card-field">
              <label class="p-col-fixed txt-right">Rent service fee rate</label>
              <div class="p-col">
                <div class="p-inputgroup">
                  <InputNumber id="rent_service_fee_rate" v-model="rent_service_fee_rate" :disabled="status!='ST001'" :min="0" :max="100" :minFractionDigits="0" :maxFractionDigits="2" @blur="syncRentResponseFinancials()"/>
                  <span class="p-inputgroup-addon">%</span>
                </div>
              </div>
            </div>

            <div class="p-card-field">
              <label class="p-col-fixed txt-right">Rent cleaning fee</label>
              <div class="p-col">
                <div class="p-inputgroup">
                  <InputNumber id="rent_cleaning_fee" v-model="rent_cleaning_fee" :disabled="status!='ST001'" :minFractionDigits="2" @blur="syncRentResponseFinancials()"/>
                  <span class="p-inputgroup-addon">EUR</span>
                </div>
              </div>
            </div>

            <div class="p-card-field">
              <label class="p-col-fixed txt-right">Other fee</label>
              <div class="p-col">
                <div class="p-inputgroup">
                  <InputNumber id="rent_other_fee" v-model="rent_other_fee" :disabled="status!='ST001'" :minFractionDigits="2" @blur="syncRentResponseFinancials()"/>
                  <span class="p-inputgroup-addon">EUR</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="p-card-field" v-if="mode == 'edit' && false">
          <label class="p-col-fixed txt-right">Note</label>
          <div class="p-col">
            <Textarea maxLength="2000" rows="2" cols="30" :autoResize="true" v-model="note"/>
          </div>
        </div>
        
        <div class="p-card-field" v-if="mode == 'edit' && type == 2">
          <label class="p-col-fixed txt-right txt-required">Contact name</label>
          <div class="p-col">
            <InputText v-model="contact_name" id="contact_name" placeholder="Input" :disabled="isCancelledStatus"/>
          </div>
        </div>
        
        <div class="p-card-field" v-if="mode == 'edit' && type == 2">
          <label class="p-col-fixed txt-right txt-required">Phone number</label>
          <div class="p-col">
            <div class="style-box-phone ml-1">
              <Dropdown  v-model="contact_prefix_phone" :options="list_phone_code" optionLabel="prefix_phone" optionValue="prefix_phone" :disabled="isCancelledStatus"/>
              <InputText type="number" id="contact_phone" class="" v-model="contact_phone"  placeholder="Input" :disabled="isCancelledStatus"/>
            </div>
            <input class="input_tmp_validator" id="prefix_phone">
          </div>
        </div>
        
        <div class="p-card-field" v-if="mode == 'edit'">
          <div class="pl-2 d-flex align-items-center">
            <Checkbox id="active" v-model="active" :binary="true" :disabled="isCancelledStatus" class="active-status-checkbox" />
            <label class="m-0 ml-3" for="active">Active</label>
          </div>
        </div>
        
        <div class="p-card-field mt-3" v-if="mode == 'edit'">
          <h4>RESPONSE ({{response.length}})</h4>
        </div>
      </div>
      <div class="col-12" v-if="type == 3">
        <div class="fee-rules-box">
          <div class="fee-rules-title">FEE RULES</div>
          <div class="fee-rules-list">
            <div>1. Total days = Departure time (check out) - Arrival time (check in)</div>
            <div>2. Total amount = Total days * Price/day</div>
            <div>3. Service fee = {{ rent_service_fee_rate || 0 }}% * (Total amount - Cleaning fee - Other fee)</div>
            <div>4. Net amount = Total amount - Cleaning fee - Other fee - Service fee</div>
          </div>
        </div>
        <div class="rent-response-table-wrap">
          <DataTable class="rent-response-table" :loading="loadResponse" :value="response" :key="`type-3-${updateDatatable}`" responsiveLayout="scroll">
          <Column field="no" header="No." :headerStyle="{width: '5em'}">
            <template #body="slotProps">
              {{slotProps.index+1}}
            </template>
          </Column>
          <Column field="avatar" header="Avatar" :headerStyle="{width: '7rem', minWidth: '7rem'}">
            <template #body="slotProps">
              <div style="width: 100%; height: 80px;">
                <img style="width:100%; height:100%" :src="slotProps.data.user.avatar.obj_file.url" v-if="slotProps.data.user && slotProps.data.user.avatar && slotProps.data.user.avatar.obj_file" />
              </div>
            </template>
          </Column>
          <Column field="fullname" header="Full name" :headerStyle="{width: '10rem', minWidth: '10rem'}">
            <template #body="slotProps">
              <a class="txt-link" :href="`/admin/list-${slotProps.data.user.role == 'renter' ? 'rent' : 'users'}/edit/${slotProps.data.user.id}`">{{slotProps.data.user.fullname}}</a>
            </template>
          </Column>
          <Column field="email" header="Email" :headerStyle="{width: '11rem', minWidth: '11rem'}">
          <template #body="slotProps">
              {{slotProps.data.user.email}}
            </template>
          </Column>
          <Column field="stay" header="Stay from - to" :headerStyle="{width: '12rem', minWidth: '12rem'}">
            <template #body="slotProps">
              <span v-if="slotProps.data.visit">{{`${getFilterDate(slotProps.data.visit.visit_start)} - ${getFilterDate(slotProps.data.visit.visit_end)}`}}</span>
            </template>
          </Column>
          <Column field="arrival" header="Arrival time" :headerStyle="{width: '10rem', minWidth: '10rem'}">
            <template #body="slotProps">
              {{getFilterDateTimeNotTimeZone(slotProps.data.arrival)}}
            </template>
          </Column>
          <Column field="departure" header="Departure time" :headerStyle="{width: '10rem', minWidth: '10rem'}">
            <template #body="slotProps">
              {{getFilterDateTimeNotTimeZone(slotProps.data.departure)}}
            </template>
          </Column>
          <Column field="total_days" header="Total days" :headerStyle="{width: '7rem', minWidth: '7rem'}">
            <template #body="slotProps">
              {{ getResponseTotalDays(slotProps.data) }}
            </template>
          </Column>
          <Column bodyStyle="width: 150px !important;" :headerStyle="{width: '12rem', minWidth: '12rem'}" field="total_amount" header="Total amount (EUR)">
            <template #body="slotProps">
              <div style="white-space: nowrap;">{{ formatResponseMoney(getResponseTotalAmount(slotProps.data)) }}</div>
            </template>
          </Column>
          <Column field="cleaning_fee" header="Cleaning fee (EUR)" :headerStyle="{width: '9rem', minWidth: '9rem'}">
            <template #body="slotProps">
              <div style="white-space: nowrap;">{{ formatResponseMoney(getResponseCleaningFee(slotProps.data)) }}</div>
            </template>
          </Column>
          <Column field="other_fee" header="Other fee (EUR)" :headerStyle="{width: '8rem', minWidth: '8rem'}">
            <template #body="slotProps">
              <div style="white-space: nowrap;">{{ formatResponseMoney(getResponseOtherFee(slotProps.data)) }}</div>
            </template>
          </Column>
          <Column field="service_fee" header="Service fee (EUR)" :headerStyle="{width: '8rem', minWidth: '8rem'}">
            <template #body="slotProps">
              <div style="white-space: nowrap;">{{ formatResponseMoney(getResponseServiceFee(slotProps.data)) }}</div>
            </template>
          </Column>
          <Column field="net_amount" header="Net amount (EUR)" :headerStyle="{width: '9rem', minWidth: '9rem'}">
            <template #body="slotProps">
              <div style="white-space: nowrap;">{{ formatResponseMoney(getResponseNetAmount(slotProps.data)) }}</div>
            </template>
          </Column>
          <Column field="created_at" header="Created date" :headerStyle="{width: '10rem', minWidth: '10rem'}">
            <template #body="slotProps">
              {{getFilterDateTime(slotProps.data.created_at)}}
            </template>
          </Column>
          <Column field="status" header="Results" :headerStyle="{width: '7rem', minWidth: '7rem'}">
            <template #body="slotProps">
              <b v-html="filterStatus(slotProps.data.status)"></b>
            </template>
          </Column>
          <Column field="update_name" header="Updated by" :headerStyle="{width: '9rem', minWidth: '9rem'}">
            <template #body="slotProps">
              <span v-if="slotProps.data.update_user">{{slotProps.data.update_user.fullname}}</span>
            </template>
          </Column>
          <Column field="updated_at" header="Updated date" :headerStyle="{width: '10rem', minWidth: '10rem'}">
            <template #body="slotProps">
              {{getFilterDateTime(slotProps.data.updated_at)}}
            </template>
          </Column>
          <Column headerClass="txt-center" bodyClass="txt-center" :headerStyle="{ width: '12rem', minWidth: '12rem' }">
            <template #header>
              <Button icon="pi pi-plus" class="p-button-success" @click="addResponse()" v-if="status == 'ST001'"/>
            </template>
            <template #body="slotProps">
              <Button icon="pi pi-pencil" class="p-button-edit response-action-button" v-if="status == 'ST001' && slotProps.data.status == 'ST001'" @click="editResponse(slotProps.index)" />
              <Button icon="pi pi-check" class="response-action-button response-action-button-accept" v-if="status == 'ST001' && slotProps.data.status == 'ST001'"  @click="showPopupAccept(slotProps.index, 'rent')" />
              <Button icon="pi pi-send" label="Send" class="response-send-email-button" v-if="slotProps.data.status == 'ST002' && !slotProps.data.is_send_email" @click="sendResponseEmail(slotProps.index)" />
              <span class="response-email-sent-label" v-if="slotProps.data.status == 'ST002' && slotProps.data.is_send_email">
                <i class="pi pi-check-circle response-email-sent-icon"></i>
                Sent
              </span>
              <Button icon="pi pi-times" v-if="status == 'ST001' && slotProps.data.status == 'ST002'" class="response-action-button response-action-button-cancel"  @click="cancelResponse(slotProps.index)" />
            </template>
          </Column>
          <template #empty>
              <div class="txt-center">No records found.</div>
          </template>
        </DataTable>
        </div>
      </div>
      <div class="col-12" v-if="type == 2">
        <DataTable :loading="loadResponse" :value="response" :key="`type-2-${updateDatatable}`">
          <Column field="no" header="No." :headerStyle="{width: '5em'}">
            <template #body="slotProps">
              {{slotProps.index+1}}
            </template>
          </Column>
          <Column field="property" header="Property">
            <template #body="slotProps">
              {{slotProps.data.property.name}}
            </template>
          </Column>
          <Column field="address" header="Address">
            <template #body="slotProps">
              {{slotProps.data.property.address}}
            </template>
          </Column>
          <Column field="owner" header="Owner">
            <template #body="slotProps">
              <a class="txt-link" :href="`/admin/list-${slotProps.data.user.role == 'renter' ? 'rent' : 'users'}/edit/${slotProps.data.user.id}`">{{slotProps.data.user.fullname}}</a>
            </template>
          </Column>
          <Column field="email" header="Email">
            <template #body="slotProps">
              {{slotProps.data.user.email}}
            </template>
          </Column>
          <Column field="week" header="Week">
            <template #body="slotProps">
              <span v-if="slotProps.data.visit">{{`Week ${slotProps.data.visit.week_number} (${getFilterDate(slotProps.data.visit.visit_start)} - ${getFilterDate(slotProps.data.visit.visit_end)})`}}</span>
            </template>
          </Column>
          <Column field="created_at" header="Created date">
            <template #body="slotProps">
              {{getFilterDateTime(slotProps.data.created_at)}}
            </template>
          </Column>
          <Column field="status" header="Result">
            <template #body="slotProps">
              <b v-html="filterStatus(slotProps.data.status)"></b>
            </template>
          </Column>
          <Column field="update_name" header="Updated by">
            <template #body="slotProps">
              <span v-if="slotProps.data.update_user">{{slotProps.data.update_user.fullname}}</span>
            </template>
          </Column>
          <Column field="updated_at" header="Updated date">
            <template #body="slotProps">
              {{getFilterDateTime(slotProps.data.updated_at)}}
            </template>
          </Column>
          <Column header="Action" headerClass="txt-center" bodyClass="txt-center">
            <template #body="slotProps">
              <Button icon="pi pi-check" v-if="status == 'ST001' && slotProps.data.status == 'ST001'"  @click="showPopupAccept(slotProps.index, 'exchange')" />
              <Button icon="pi pi-times" v-if="status == 'ST001' && slotProps.data.status == 'ST002'" class="p-button-danger"  @click="cancelResponse(slotProps.index)" />
            </template>
          </Column>
          <template #empty>
              <div class="txt-center">No records found.</div>
          </template>
        </DataTable>
      </div>
      <Toolbar class="fixed-bottom-toolbar div-button">
        <template slot="left">
          <Button
              v-if="status == 'ST001' && type == 3"
              label="Cancel request"
              @click="cancelAvailable()"
              class="p-button-secondary"
          />
        </template>
        <template slot="right">
          <Button
              :label="$constants.TEXT_BUTTON.BACK"
              @click="backToList()"
              class="p-button-outlined"
              id="back"
          />
          <Button
              v-if="mode == 'edit' && !isAcceptedStatus"
              :label="$constants.TEXT_BUTTON.EDIT"
              @click="saveData()"
              class="main-style-button"
              :disabled="isCancelledStatus"
          />
          <Button
              v-if="mode != 'edit'"
              :label="$constants.TEXT_BUTTON.ADD"
              @click="saveData()"
              class="main-style-button"
          />
        </template>
      </Toolbar>
      <Dialog header="Confirmation" :visible.sync="popupCancelAvailable" :style="{width: '50vw'}" >
        Are you cancel this request?
        <template #footer>
            <Button label="Cancel" icon="pi pi-times" class="p-button-secondary" @click="popupCancelAvailable = false"/>
            <Button label="Confirm" icon="pi pi-check" @click="confirmCancelAvailable"/>
        </template>
      </Dialog>
      <Dialog header="Confirmation" :visible.sync="popupConfirmAccept" :style="{width: '50vw'}" >
        Are you accept this request?
        <template #footer>
            <Button label="Cancel" icon="pi pi-times" class="p-button-secondary" @click="popupConfirmAccept = false"/>
            <Button label="Confirm" icon="pi pi-check" @click="acceptResponse"/>
        </template>
      </Dialog>
      <!-- position="right"  -->
    <Dialog :header="responseDialogTitle" :visible.sync="showPopupAdd" :style="{width: responseDialogWidth}" class="response-dialog" :modal="true" :closable="true" :contentStyle="{ overflowY: 'auto', overflowX: 'hidden', maxHeight: 'calc(88vh - 126px)' }">
        <form id="frm_action_add">
            <div class="response-dialog-body">
                  <label class="response-dialog-label txt-required">Choose a user/ renter</label>
                  <div class="p-col response-dialog-control">
                      <v-select style=""  :clearable="false" :getOptionLabel="filterUser" :searchable="true" title="Owner/ renter" class="w-100 mb-4 response-user-select" @search="searchListUser" placeholder="Choose" v-model="selUser" :options="listUser" :disabled="responseDialogMode === 'edit'">
                          <span slot="no-options" @click="$refs.select.open = false">
                              Empty data
                          </span>
                          <template
                            #selected-option-container="{option}"
                          >
                            <div class="vs__selected txt-ellipsis">
                              {{ getLabelListUser(option) }}
                            </div>
                          </template>
                          <template #option="option">
                              {{ getLabelListUser(option) }}
                          </template>
                          
                          <template #selected-option="option">
                              {{ getLabelListUser(option) }}
                          </template>
                      </v-select>
                      <input class="input_tmp_validator" id="choose_user">
                  </div>
                <div class="response-dialog-grid" v-if="type==3">
                 <div class="response-dialog-field">
                  <label class="response-dialog-label txt-required">Arrival time</label>
                  <div class="p-col response-dialog-control">
                     <Calendar
                  
                  :showOnFocus="false"
                  dateFormat="dd/mm/yy"
                  id="end_booking_date"
                  :showIcon="true"
                  appendTo="self"
                  :baseZIndex="100000"
                  panelStyleClass="response-calendar-panel"
                  :showClear="true"
                  :manualInput="true"
                  v-model="arrival"
                  placeholder="Choose"
                  :showTime="true"
                  :showSeconds="false"
                 
                />
                  </div>
                  </div>

                  <div class="response-dialog-field">
                  <label class="response-dialog-label txt-required">Departure time</label>
                  <div class="p-col response-dialog-control">
                     <Calendar
                  
                  :showOnFocus="false"
                  dateFormat="dd/mm/yy"
                  id="end_booking_date"
                  :showIcon="true"
                  appendTo="self"
                  :baseZIndex="100000"
                  panelStyleClass="response-calendar-panel"
                  :showClear="true"
                  :manualInput="true"
                  v-model="departure"
                  placeholder="Choose"
                  :showTime="true"
                  :showSeconds="false"
                 
                />
                  </div>
                  </div>
                </div>
                <div v-if="type == 3" class="response-dialog-grid response-dialog-grid-secondary">
                  <div class="response-dialog-field">
                    <label class="response-dialog-label">Total days</label>
                    <div class="p-col response-dialog-control">
                      <InputText :value="String(responseDialogMetrics.total_days)" disabled />
                    </div>
                  </div>
                  <div class="response-dialog-field">
                    <label class="response-dialog-label">Total amount (EUR)</label>
                    <div class="p-col response-dialog-control">
                      <InputText :value="formatResponseMoney(responseDialogMetrics.total_amount)" disabled />
                    </div>
                  </div>
                  <div class="response-dialog-field">
                    <label class="response-dialog-label">Cleaning fee</label>
                    <div class="p-col response-dialog-control">
                      <InputNumber v-model="responseEditCleaningFee" :min="0" :minFractionDigits="2" />
                    </div>
                  </div>
                  <div class="response-dialog-field">
                    <label class="response-dialog-label">Other fee</label>
                    <div class="p-col response-dialog-control">
                      <InputNumber v-model="responseEditOtherFee" :min="0" :minFractionDigits="2" />
                    </div>
                  </div>
                  <div class="response-dialog-field">
                    <label class="response-dialog-label">Service fee</label>
                    <div class="p-col response-dialog-control">
                      <InputText :value="formatResponseMoney(responseDialogMetrics.service_fee)" disabled />
                    </div>
                  </div>
                  <div class="response-dialog-field">
                    <label class="response-dialog-label">Net amount</label>
                    <div class="p-col response-dialog-control">
                      <InputText :value="formatResponseMoney(responseDialogMetrics.net_amount)" disabled />
                    </div>
                  </div>
                </div>
                <div class="response-dialog-status">
                  <label class="response-dialog-label">Status</label>
                  <div class="p-col response-dialog-control">
                    <Dropdown
                      v-model="responseEditStatus"
                      :options="responseStatus"
                      optionLabel="label"
                      optionValue="value"
                      placeholder="Choose"
                    />
                  </div>
                </div>
            </div>
            
        </form>
        <template #footer>
            <Button label="Cancel" class="response-dialog-cancel" @click="closeResponseDialog"/>
            <Button :label="responseDialogMode === 'edit' ? 'Save' : 'Confirm'" class="response-dialog-submit" @click="confirmPopupAdd"/>
        </template>
    </Dialog>
    <Dialog
      header="Exchange option"
      :visible.sync="showOptionDialog"
      :style="{width: '72vw', maxWidth: '980px'}"
      :contentStyle="{overflow: 'visible'}"
      class="exchange-option-dialog"
      :modal="true">
      <div class="p-fluid">
        <div v-if="isCancelledStatus" class="p-message p-message-warn mb-3">
          Exchange cancelled - editing is disabled.
        </div>
        <div class="p-field mb-3">
          <label>Rule type</label>
          <div class="exchange-rule-radio-group">
            <div class="exchange-rule-radio-item" v-for="rule in exchangeRuleTypes" :key="`rule-type-${rule.value}`">
              <RadioButton :inputId="`rule-type-${rule.value}`" name="ruleType" :value="rule.value" v-model="optionDraft.type_rule" @change="onOptionRuleTypeChange(rule.value)" :disabled="isCancelledStatus" />
              <label :for="`rule-type-${rule.value}`">{{ rule.label }}</label>
            </div>
          </div>
        </div>
        <div class="p-field mb-3">
          <label>Weeks</label>
          <v-select :multiple="true" :clearable="true" placeholder="Choose week" v-model="optionDraftWeeks" :options="listWeek" :disabled="isCancelledStatus">
            <template slot="option" slot-scope="option">
              {{ `Week ${getWeekDate(option.visit_start)} (${getFilterDate(option.visit_start)} - ${getFilterDate(option.visit_end)})`}}
            </template>
            <template slot="selected-option" slot-scope="option">
              {{ `Week ${getWeekDate(option.visit_start)} (${getFilterDate(option.visit_start)} - ${getFilterDate(option.visit_end)})`}}
            </template>
          </v-select>
          <div class="mt-2 d-flex flex-wrap week-chip-list" v-show="optionDraftWeeks.length > 0">
            <span class="d-flex chip-box m-2 justify-content-between align-items-center" v-for="(item, index) in optionDraftWeeks" :key="`week-draft-chip-${index}`">
              <span>{{ `Week ${getWeekDate(item.visit_start)} (${getFilterDate(item.visit_start)} - ${getFilterDate(item.visit_end)})` }}</span>
              <span class="clear" @click="optionDraftWeeks.splice(index, 1)" v-if="!isCancelledStatus"><i class="pi pi-times"></i></span>
            </span>
          </div>
        </div>
        <div class="p-field mb-3" v-if="optionDraft.type_rule == 1 || optionDraft.type_rule == 2">
          <label>{{ optionDraft.type_rule == 1 ? 'My properties' : 'Specific properties' }}</label>
          <v-select :multiple="true" :clearable="true" placeholder="Choose property" v-model="optionDraftProperties" :options="optionDraftPropertySource" label="name" :disabled="isCancelledStatus">
            <template #option="option">
              <div class="property-option-row">
                <div class="property-option-title">{{ option.code }} - {{ option.name }}</div>
                <div class="property-option-address">{{ option.address || '' }}</div>
              </div>
            </template>
            <template #selected-option="option">
              {{ option.code }} - {{ option.name }}
            </template>
          </v-select>
          <div class="mt-2 d-flex flex-wrap week-chip-list" v-show="optionDraftProperties.length > 0">
            <span class="d-flex chip-box m-2 justify-content-between align-items-center" v-for="(item, index) in optionDraftProperties" :key="`property-chip-${index}`">
              <span>{{ item.code }} - {{ item.name }}</span>
              <span class="clear" @click="optionDraftProperties.splice(index, 1)" v-if="!isCancelledStatus"><i class="pi pi-times"></i></span>
            </span>
          </div>
        </div>
      </div>
      <template #footer>
        <Button label="Cancel" class="p-button-text" @click="showOptionDialog = false"/>
        <Button label="Apply" @click="confirmOptionDialog"/>
      </template>
    </Dialog>
    </div>
  </form>
</template>
<script>
import DataServices from '@/core/DataServices';
import moment from "moment-timezone";
import ApiRepository from "@/core/ApiRepository";
export default {
  components: {
  },
  props: {
    mode: String,
    model: Object,
    users: Array
  },
  data() {
    return {
      loadResponse: false,
      contact_prefix_phone: null,
      list_phone_code: [
        {
          prefix_phone:"+84",
        },
        {
          prefix_phone:"+45",
        }
      ],
      responseStatus: [
        {value: "ST001", label: "Pending", color: "#000000"},
        {value: "ST002", label: "Accepted", color: "#28A745"},
        {value: "ST003", label: "Cancelled", color: "#F5564E"},
      ],
      loadUser: false,
      showPopupAdd:false,
      selUser: null,
      listUser: [],
      listUserAll: [],
      priceOld:0,
      rent_thirdparty_priceOld:0,
      is_admin_update_price: false,
      total: 0,
      selStatus: null,
      active: true,
      my_property: false,
      owner_name: null,
      type_name: 'Rent request',
      property_id: null,
      property_name: null,
      property_code: null,
      property_address: null,
      week_name: null,
      type: 3,
      note: null,
      status: 'ST001',
      price: 0,
      rent_thirdparty_price: 0,
      rent_service_fee_rate: 0,
      rent_cleaning_fee: 0,
      rent_other_fee: 0,
      price_tmp_check: 0,
      rent_thirdparty_price_tmp_check: 0,
      deposit: 0,
      response: [],
      time_zone_local : moment.tz.guess(true),
      selOwnerProperty: null,
      listOwnerProperty: [],
      listOwnerPropertyAll: [],
      contact_name: null,
      contact_phone: null,
      listWeek: [],
      selWeek: [],
      uid: null,
      dataConfirmAccept: null,
      popupConfirmAccept: false,
      updateDatatable: 0,
      popupCancelAvailable: false,
      responseTmp: null,
      arrival: null,
      departure: null,
      responseDialogMode: 'add',
      editingResponseIndex: null,
      responseEditStatus: 'ST001',
      responseEditCleaningFee: 0,
      responseEditOtherFee: 0,
      loadEdit: 0,
      componentKey: 0,
      listRuleExchange: [],
      showOptionDialog: false,
      editingOptionIndex: null,
      optionDraft: {
        type_rule: 3
      },
      optionDraftWeeks: [],
      optionDraftProperties: [],
      optionDialogHydrating: false,
      optionRuleTypeLast: null,
      myOwnPropertyOptions: [],
      systemPropertyOptions: [],
      exchangeRuleTypes: [
        { value: 1, label: 'My own property' },
        { value: 2, label: 'A specific property' },
        { value: 3, label: 'Any property' }
      ]
    }
  },
  computed: {
    isCancelledStatus() {
      return this.status === 'ST003' || this.selStatus?.value === 'ST003';
    },
    isAcceptedStatus() {
      console.log("this.statusthis.statusthis.status:",this.status)
      return this.status === 'ST002' || this.selStatus?.value === 'ST002';
    },
    responseDialogTitle() {
      return this.responseDialogMode === 'edit' ? 'Edit Response' : 'Add new response';
    },
    responseDialogWidth() {
      return this.responseDialogMode === 'edit' ? '40rem' : '38rem';
    },
    responseDialogMetrics() {
      const draft = {
        user: this.selUser,
        arrival: this.arrival,
        departure: this.departure,
        cleaning_fee: this.responseEditCleaningFee,
        other_fee: this.responseEditOtherFee
      };
      return {
        total_days: this.getResponseTotalDays(draft),
        total_amount: this.getResponseTotalAmount(draft),
        cleaning_fee: this.getResponseCleaningFee(draft),
        other_fee: this.getResponseOtherFee(draft),
        service_fee: this.getResponseServiceFee(draft),
        net_amount: this.getResponseNetAmount(draft)
      };
    },
    optionDraftPropertySource() {
      if (parseInt(this.optionDraft?.type_rule || 0) === 1) {
        return this.myOwnPropertyOptions;
      }
      if (parseInt(this.optionDraft?.type_rule || 0) === 2) {
        return this.systemPropertyOptions;
      }
      return [];
    }
  },
  watch: {
    "model.list_rule_exchange": {
      deep: true,
      handler(newVal) {
        console.log('[DBG][available][add] watcher model.list_rule_exchange', newVal);
        if (Array.isArray(newVal) && newVal.length > 0) {
          this.listRuleExchange = newVal.map(rule => ({
            type_rule: parseInt(rule?.type_rule || 3),
            property_ids: Array.isArray(rule?.property_ids) ? [...rule.property_ids] : [],
            list_week_change: Array.isArray(rule?.list_week_change) ? [...rule.list_week_change] : []
          }));
          console.log('[DBG][available][add] synced listRuleExchange', this.listRuleExchange);
        }
      }
    },
    async "selUser"() {
      if (this.selUser?.id) {
        var fileData = await this.$apollo.query({
            query: DataServices.getList('relationship_file', {
            "fields" : `id obj_file{url}`
          }),
          variables: {
            where_key: {
              obj_id: {'_eq': this.selUser.id},
              type: {'_eq': 'USER_AVATAR'}
            }
          },
          fetchPolicy: "network-only"
        })
        var avatar = fileData?.data?.relationship_file[0];
        this.selUser.avatar = avatar;
      }
    },
    async "my_property"() {
      await this.getListOwnerProperty();
      // if (this.my_property) {
      //   await this.changeResponse();
      // } else {
      //   // if (this.selOwnerProperty?.id) {
      //   //   let indexOf = this.response.indexOf(this.response.filter(f => f?.user?.id == this.selOwnerProperty?.id)[0]);
      //   //   if (indexOf != -1) {
      //   //     this.response.splice(indexOf, 1);
      //   //   }
      //   // }
      //   if (this.responseTmp?.user) {
      //     let indexOf = this.response.indexOf(this.responseTmp);
      //     if (indexOf != -1) {
      //       this.response.splice(indexOf, 1);
      //     }
      //   }
      // }
    },
    "price" () {
      if (this.price != this.priceOld && this.price != this.model.price) {
        this.is_admin_update_price = true;
      }
    },
    "rent_thirdparty_price" () {
      if (this.rent_thirdparty_price != this.rent_thirdparty_priceOld && this.rent_thirdparty_price != this.model.rent_thirdparty_price) {
        this.is_admin_update_price = true;
      }
    },
    "rent_service_fee_rate" () {
      this.syncRentResponseFinancials();
    },
    "rent_cleaning_fee" () {
      this.syncRentResponseFinancials();
    },
    "rent_other_fee" () {
      this.syncRentResponseFinancials();
    },
    async "selOwnerProperty"() {
      if (this.loadEdit == 1) {
        this.loadEdit = 0;
        return;
      }
      // await this.changeResponse();
    },
  },
  async mounted() {
    this.response = [];
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      this.loadEdit = 1;
      this.type = parseInt(this.model.type || 3);
      this.uid = this.model.created_by;
      this.response = this.model.response;
     
      // for (let i = 0; i < this.response.length; i++) {
      //   //check empty
      //    if (!this.$commonFuction.isEmpty(this.response[i].arrival)){
      //      this.response[i].arrival = moment.tz(this.response[i].arrival, this.time_zone_local).format("YYYY-MM-DD HH:mm:ss");
      //    }
      //    //
      //     if (!this.$commonFuction.isEmpty(this.response[i].departure)){
      //       this.response[i].departure = moment(this.response[i].departure).tz(this.response[i].arrival, this.time_zone_local).format("YYYY-MM-DD HH:mm:ss");
      //     }
      // }
      console.log("this.response111", this.response);
      this.selWeek = this.model.week;
      this.my_property = this.model.my_property;
      if (Array.isArray(this.model.list_rule_exchange) && this.model.list_rule_exchange.length > 0) {
        this.listRuleExchange = this.model.list_rule_exchange.map(rule => ({
          type_rule: parseInt(rule?.type_rule || 3),
          property_ids: Array.isArray(rule?.property_ids) ? [...rule.property_ids] : [],
          list_week_change: Array.isArray(rule?.list_week_change) ? [...rule.list_week_change] : []
        }));
      } else if (Array.isArray(this.selWeek) && this.selWeek.length > 0) {
        this.listRuleExchange = [{
          type_rule: this.my_property ? 1 : 3,
          property_ids: [],
          list_week_change: this.selWeek.map(w => ({
            visit_start_mi: moment(w.visit_start).valueOf(),
            visit_end_mi: moment(w.visit_end).valueOf(),
            visit_start: w.visit_start,
            visit_end: w.visit_end
          }))
        }];
      }
      this.property_id = this.model.property.id;
      this.property_name = this.model.property.name;
      this.property_code = this.model.property.code;
      this.property_address = this.model.property.address;
      this.contact_name = this.model.contact_name;
      this.contact_prefix_phone = this.model.contact_prefix_phone;
      this.contact_phone = this.model.contact_phone;
      this.type_name = [{value: 2, label: 'Exchange request'}, {value: 3, label: 'Rent request'}].filter(f => f.value == this.type)[0]?.label || 'Rent request';
      this.selStatus = (this.$constants.AVAILABLE_STATUS[this.type] || []).filter(f => f.value == this.model.status)[0] || null;
      this.note = this.model.note;
      this.owner_name = this.model?.create_user?.fullname;
      this.status = this.model.status;
      this.old_status = this.model.status;
      this.price = this.model.price;
      this.rent_thirdparty_price = this.model.rent_thirdparty_price;
      this.priceOld = this.model.price;
      this.price_tmp_check = this.model.price;
      this.rent_thirdparty_priceOld = this.model.rent_thirdparty_price;
      this.rent_thirdparty_price_tmp_check = this.model.rent_thirdparty_price;
      this.rent_service_fee_rate = this.model.rent_service_fee_rate ?? 0;
      this.rent_cleaning_fee = this.model.rent_cleaning_fee ?? 0;
      this.rent_other_fee = this.model.rent_other_fee ?? 0;
      this.deposit = this.model.deposit;
      this.week_name = `Week ${this.model.visit.week_number} (${this.getFilterDate(this.model.visit.visit_start)} - ${this.getFilterDate(this.model.visit.visit_end)})`
      this.selOwnerProperty = this.model.owner;

       this.convertDataResponse();
      this.syncAvailableStatusFromResponses();
      this.updateDatatable++;
    }
    if (this.type == 2) {
      await this.getListWeek();
      await this.getListOwnerProperty();
      await this.getMyOwnPropertyOptions();
      await this.getSystemPropertyOptions();
    }
    if (this.type == 3) {
      await this.getListUser();
    }
  },
  methods: {
    getRuleTypeLabel(typeRule) {
      const found = this.exchangeRuleTypes.find(item => parseInt(item.value) === parseInt(typeRule));
      return found ? found.label : 'Any property';
    },
    getOptionPropertyNames(option = {}) {
      const ids = Array.isArray(option?.property_ids) ? option.property_ids : [];
      if (ids.length < 1) {
        return [];
      }
      const listFromOption = Array.isArray(option?.list_property) ? option.list_property : [];
      const mapById = {};
      listFromOption.forEach(item => {
        if (item?.id) {
          mapById[item.id] = item;
        }
      });
      this.myOwnPropertyOptions.forEach(item => {
        if (item?.id && !mapById[item.id]) {
          mapById[item.id] = item;
        }
      });
      this.systemPropertyOptions.forEach(item => {
        if (item?.id && !mapById[item.id]) {
          mapById[item.id] = item;
        }
      });
      return ids.map(id => {
        const item = mapById[id];
        if (!item) return id;
        const code = item?.code ? `${item.code} - ` : '';
        return `${code}${item?.name || id}`;
      });
    },
    formatWeekByMs(startMs, endMs) {
      if (this.$commonFuction.isEmpty(startMs) || this.$commonFuction.isEmpty(endMs)) return '';
      const start = moment(parseInt(startMs));
      const end = moment(parseInt(endMs));
      return `Week ${this.getWeekDate(start)} (${this.getFilterDate(start)} - ${this.getFilterDate(end)})`;
    },
    openOptionDialog(index = null) {
      if (this.isCancelledStatus) {
        return;
      }
      this.optionDialogHydrating = true;
      this.editingOptionIndex = index;
      console.log('[DBG][available][add] openOptionDialog:start', {
        index,
        listRuleExchange: this.listRuleExchange,
        myOwnPropertyOptions: this.myOwnPropertyOptions,
        systemPropertyOptions: this.systemPropertyOptions
      });
      if (index === null) {
        this.optionDraft = { type_rule: 3 };
        this.optionDraftWeeks = [];
        this.optionDraftProperties = [];
      } else {
        const current = this.listRuleExchange[index];
        console.log('[DBG][available][add] openOptionDialog:current', current);
        this.optionDraft = { type_rule: parseInt(current?.type_rule || 3) };
        this.optionDraftWeeks = (current?.list_week_change || []).map(w => ({
          visit_start: w.visit_start || moment(parseInt(w.visit_start_mi)).toDate(),
          visit_end: w.visit_end || moment(parseInt(w.visit_end_mi)).toDate(),
          visit_start_mi: w.visit_start_mi,
          visit_end_mi: w.visit_end_mi
        }));
        const ids = current?.property_ids || [];
        const source = (parseInt(this.optionDraft.type_rule) === 1) ? this.myOwnPropertyOptions : this.systemPropertyOptions;
        const sourceResolved = (source && source.length > 0) ? source : this.systemPropertyOptions;
        this.optionDraftProperties = sourceResolved.filter(x => ids.includes(x?.id));
        console.log('[DBG][available][add] openOptionDialog:map-properties', {
          ids,
          sourceSize: source?.length || 0,
          sourceResolvedSize: sourceResolved?.length || 0,
          mapped: this.optionDraftProperties
        });
        if (this.optionDraftProperties.length < ids.length && ids.length > 0) {
          this.loadPropertyOptionsByIds(ids).then(extraProps => {
            const merged = [...sourceResolved];
            extraProps.forEach(p => {
              if (!merged.find(x => x.id === p.id)) merged.push(p);
            });
            this.optionDraftProperties = merged.filter(x => ids.includes(x?.id));
            console.log('[DBG][available][add] openOptionDialog:fallback-properties', {
              ids,
              extraProps,
              mappedAfterFallback: this.optionDraftProperties
            });
          });
        }
      }
      this.optionRuleTypeLast = parseInt(this.optionDraft?.type_rule || 3);
      this.optionDialogHydrating = false;
      this.showOptionDialog = true;
      console.log('[DBG][available][add] openOptionDialog:end', {
        optionDraft: this.optionDraft,
        optionDraftWeeks: this.optionDraftWeeks,
        optionDraftProperties: this.optionDraftProperties
      });
    },
    onOptionRuleTypeChange(newType) {
      const nextType = parseInt(newType || this.optionDraft?.type_rule || 3);
      const prevType = parseInt(this.optionRuleTypeLast || 0);
      if (prevType !== 0 && prevType !== nextType) {
        this.optionDraftProperties = [];
      }
      this.optionRuleTypeLast = nextType;
    },
    removeOption(index) {
      if (this.isCancelledStatus) {
        return;
      }
      this.listRuleExchange.splice(index, 1);
    },
    confirmOptionDialog() {
      if (!Array.isArray(this.optionDraftWeeks) || this.optionDraftWeeks.length < 1) {
        this.$toast.add({ severity: 'warn', summary: 'Warning', detail: 'Please choose week', life: 2500 });
        return;
      }
      const payload = {
        type_rule: parseInt(this.optionDraft?.type_rule || 3),
        list_week_change: this.optionDraftWeeks.map(w => {
          const s = w.visit_start_mi || moment(w.visit_start).valueOf();
          const e = w.visit_end_mi || moment(w.visit_end).valueOf();
          return {
            visit_start_mi: s,
            visit_end_mi: e
          };
        }),
        property_ids: (this.optionDraftProperties || []).map(x => x?.id).filter(Boolean)
      };
      if (payload.type_rule !== 2) {
        payload.property_ids = payload.type_rule === 1 ? payload.property_ids : [];
      }
      if (this.editingOptionIndex === null) {
        this.listRuleExchange.push(payload);
      } else {
        this.$set(this.listRuleExchange, this.editingOptionIndex, payload);
      }
      this.showOptionDialog = false;
    },
    async getMyOwnPropertyOptions() {
      if (!this.uid) {
        this.myOwnPropertyOptions = [];
        return;
      }
      let map = {};
      try {
        const { data } = await this.$apollo.query({
          query: DataServices.getList('admin_property', {"fields": `id uid property{id code name address}`}),
          variables: {
            where_key: {
              uid: { _eq: this.uid }
            },
            orderBy: [{ id: 'desc' }]
          },
          fetchPolicy: "network-only"
        });
        const rows = data?.admin_property || [];
        rows.forEach(r => {
          const p = r?.property;
          if (p?.id && !map[p.id]) {
            map[p.id] = { id: p.id, code: p.code || '', name: p.name || '', address: p.address || '' };
          }
        });
      } catch (e) {
        console.log('getMyOwnPropertyOptions admin_property failed', e);
      }
      // fallback for older schema
      if (Object.keys(map).length < 1) {
        try {
          const { data } = await this.$apollo.query({
            query: DataServices.getList('property_part', {"fields": `id obj_property{id code name address} uid`}),
            variables: {
              where_key: {
                uid: { _eq: this.uid }
              },
              orderBy: [{ order_booking: 'desc' }, { id: 'desc' }]
            },
            fetchPolicy: "network-only"
          });
          const rows = data?.property_part || [];
          rows.forEach(r => {
            const p = r?.obj_property;
            if (p?.id && !map[p.id]) {
              map[p.id] = { id: p.id, code: p.code || '', name: p.name || '', address: p.address || '' };
            }
          });
        } catch (e) {
          console.log('getMyOwnPropertyOptions property_part failed', e);
        }
      }
      this.myOwnPropertyOptions = Object.values(map);
    },
    async getSystemPropertyOptions() {
      const { data } = await this.$apollo.query({
        query: DataServices.getList('property', {"fields": `id code name address`}),
        variables: {
          where_key: {
            deleted: { _eq: false }
          },
          orderBy: [{ created_at: 'desc' }]
        },
        fetchPolicy: "network-only"
      });
      const rows = data?.property || [];
      this.systemPropertyOptions = rows.map(p => ({
        id: p.id,
        code: p.code || '',
        name: p.name || '',
        address: p.address || ''
      }));
    },
    async loadPropertyOptionsByIds(ids = []) {
      if (!Array.isArray(ids) || ids.length < 1) return [];
      try {
        const { data } = await this.$apollo.query({
          query: DataServices.getList('property', {"fields": `id code name address`}),
          variables: {
            where_key: {
              id: { _in: ids }
            }
          },
          fetchPolicy: "network-only"
        });
        const rows = data?.property || [];
        return rows.map(p => ({
          id: p.id,
          code: p.code || '',
          name: p.name || '',
          address: p.address || ''
        }));
      } catch (e) {
        console.log('loadPropertyOptionsByIds failed', e);
        return [];
      }
    },
    changePrice(event, type){
      console.log("changePric11e", this.price);//
      
      this.syncRentResponseFinancials();
      var price = this?.price ?? 0;
      var rent_thirdparty_price = this?.rent_thirdparty_price ?? 0;
      var price_tmp_check = this?.price_tmp_check ?? 0;
      var rent_thirdparty_price_tmp_check = this?.rent_thirdparty_price_tmp_check ?? 0;
      var is_change = false ;
      if(type == 'price'){
        if(price != price_tmp_check){
          is_change = true;
        }
      }else{
        if(rent_thirdparty_price != rent_thirdparty_price_tmp_check){
          is_change = true;
        }
      }
      if(is_change){
          this.$toast.add({
            severity: 'warn', // hoặc 'info' nếu muốn nhẹ hơn
            summary: 'Price Changed',
            detail: 'The price has been changed. Please check again before saving.',
            life: 4000 // thời gian hiển thị (ms)
        })
      }

    if(type == 'price'){
        this.price_tmp_check = this.price;
    }else{
      this.rent_thirdparty_price_tmp_check = this.rent_thirdparty_price;
    }
    },
    syncRentResponseFinancials() {
      if (parseInt(this.type || 0) !== 3) {
        return;
      }
      if (!Array.isArray(this.response) || this.response.length < 1) {
        return;
      }
      this.convertDataResponse();
      this.updateDatatable++;
    },
     async convertDataResponse() {
      
      var response = this.$commonFuction.convertJsonObject(this.response);
      var admin_property_list_uid = [];
      if(this.model.property.admin_property_list && this.model.property.admin_property_list.length > 0){
        admin_property_list_uid = this.model.property.admin_property_list.map(m1 => m1.uid);
      }
      console.log("admin_property_list_uid", admin_property_list_uid);
      response.map(m => {
        if (this.type == 3) {
          Object.assign(m, this.buildResponseFinancials(m));
        }
      })
      console.log("response", response);//
      this.response = response;
     },
    async changeResponse() {
      if (this.selOwnerProperty?.id) {
        if (this.responseTmp?.user) {
          let indexOf = this.response.indexOf(this.responseTmp);
          if (indexOf != -1) {
            this.response.splice(indexOf, 1);
          }
        }
        let checkRes = this.response.filter(f => f?.user?.id == this.selOwnerProperty?.id);
        console.log("checkRescheckRes", this.response);
        console.log("checkRescheckRes", checkRes);
        if (checkRes.length > 0) {
          return;
        }
        this.loadResponse = true;
        var fileData = await this.$apollo.query({
            query: DataServices.getList('relationship_file', {
            "fields" : `id obj_file{url}`
          }),
          variables: {
            where_key: {
              obj_id: {'_eq': this.selOwnerProperty.id},
              type: {'_eq': 'USER_AVATAR'}
            }
          },
          fetchPolicy: "network-only"
        })
        var avatar = fileData?.data?.relationship_file[0];
        this.selOwnerProperty.avatar = avatar;
        this.responseTmp = {
          user: this.selOwnerProperty,
          owner: this.selOwnerProperty,
          property: {
            id: this.property_id,
            address: this.property_address,
            name: this.property_name
          },
          is_new: true,
          status: "ST001",
          old_status: "",
          created_at: new Date(),
          updated_at: new Date(),
          updated_by: this.$store.getters.user
        }
        this.response.push(this.responseTmp)
        this.loadResponse = false;
      }
    },
    getLabelListUser(data) {
      let txt = `${data.fullname} - ${data.email}`;
      if (data?.arr_part && data.arr_part.length > 0) {
        let arr_txt = [];
        data.arr_part.map(m => {
          arr_txt.push(m?.obj_property.name);
        })
        txt += `(${arr_txt.join(', ')})`;
      }
      return txt;
    },
    filterStatus(data) {
      var filter = this.responseStatus.filter(f => f.value == data);
      return `<span style="color: ${filter[0]?.color}">${filter[0]?.label}</span>`;
    },
    isStatusSelectable(option) {
      if (!option) {
        return false;
      }
      return option.value !== 'ST002';
    },
    getResponseAvatarUrl(item) {
      return item?.user?.avatar?.obj_file?.url || '';
    },
    getResponseTotalDays(item) {
      if (item && item.total_days !== undefined && item.total_days !== null && item.total_days !== '') {
        return parseInt(item.total_days || 0);
      }
      const arrival = item?.arrival;
      const departure = item?.departure;
      if (this.$commonFuction.isEmpty(arrival) || this.$commonFuction.isEmpty(departure)) {
        return 0;
      }
      const arrivalFormat = moment(arrival).format("YYYY-MM-DD");
      const departureFormat = moment(departure).format("YYYY-MM-DD");
      const diffDays = moment(departureFormat).diff(moment(arrivalFormat), 'days');
      return diffDays < 1 ? 1 : diffDays;
    },
    getResponseUnitPrice(item) {
      const uid = item?.user?.id;
      const adminPropertyList = this.model?.property?.admin_property_list || [];
      const adminPropertyListUid = adminPropertyList.map(entry => entry.uid);
      return adminPropertyListUid.includes(uid) ? parseFloat(this.price || 0) : parseFloat(this.rent_thirdparty_price || 0);
    },
    getResponseTotalAmount(item, forceRecalculate = false) {
      if (!forceRecalculate && item && item.total_amount !== undefined && item.total_amount !== null && item.total_amount !== '') {
        return parseFloat(item.total_amount || 0);
      }
      return this.getResponseTotalDays(item) * this.getResponseUnitPrice(item);
    },
    getResponseCleaningFee(item = null, forceRecalculate = false) {
      if (!forceRecalculate && item && item.cleaning_fee !== undefined && item.cleaning_fee !== null && item.cleaning_fee !== '') {
        return parseFloat(item.cleaning_fee || 0);
      }
      return parseFloat(this.rent_cleaning_fee || 0);
    },
    getResponseOtherFee(item = null, forceRecalculate = false) {
      if (!forceRecalculate && item && item.other_fee !== undefined && item.other_fee !== null && item.other_fee !== '') {
        return parseFloat(item.other_fee || 0);
      }
      return parseFloat(this.rent_other_fee || 0);
    },
    getResponseServiceFee(item, forceRecalculate = false) {
      if (!forceRecalculate && item && item.service_fee !== undefined && item.service_fee !== null && item.service_fee !== '') {
        return parseFloat(item.service_fee || 0);
      }
      const baseAmount = this.getResponseTotalAmount(item, forceRecalculate) - this.getResponseCleaningFee(item, forceRecalculate) - this.getResponseOtherFee(item, forceRecalculate);
      return (baseAmount * parseFloat(this.rent_service_fee_rate || 0)) / 100;
    },
    getResponseNetAmount(item, forceRecalculate = false) {
      if (!forceRecalculate && item && item.net_amount !== undefined && item.net_amount !== null && item.net_amount !== '') {
        return parseFloat(item.net_amount || 0);
      }
      return this.getResponseTotalAmount(item, forceRecalculate) - this.getResponseCleaningFee(item, forceRecalculate) - this.getResponseOtherFee(item, forceRecalculate) - this.getResponseServiceFee(item, forceRecalculate);
    },
    buildResponseFinancials(item) {
      const forceRecalculate = true;
      return {
        total_days: this.getResponseTotalDays(item),
        total_amount: this.getResponseTotalAmount(item, forceRecalculate),
        cleaning_fee: this.getResponseCleaningFee(item, forceRecalculate),
        other_fee: this.getResponseOtherFee(item, forceRecalculate),
        service_fee: this.getResponseServiceFee(item, forceRecalculate),
        net_amount: this.getResponseNetAmount(item, forceRecalculate)
      };
    },
    syncAvailableStatusFromResponses() {
      const hasAcceptedResponse = (this.response || []).some((item) => item?.status === 'ST002');
      const nextStatus = hasAcceptedResponse ? 'ST002' : (this.model?.status || 'ST001');
      this.status = nextStatus;
      const availableStatuses = this.$constants.AVAILABLE_STATUS[this.type] || [];
      const matchedStatus = availableStatuses.find((item) => item.value === nextStatus);
      if (matchedStatus) {
        this.selStatus = matchedStatus;
      }
    },
    async persistAcceptedResponse(responseItem) {
      if (!responseItem) {
        return;
      }
      this.dataConfirmAccept = responseItem;
      this.dataConfirmAccept.type = this.type == 2 ? 'exchange' : 'rent';
      await this.acceptResponse();
    },
    async persistResponseImmediately(responseItem) {
      if (!responseItem || this.mode !== 'edit' || !this.model?.id) {
        return responseItem;
      }
      if (responseItem?.status === 'ST002') {
        await this.persistAcceptedResponse(responseItem);
        return responseItem;
      }

      if (responseItem?.is_new || !responseItem?.id) {
        const list = this.buildAvailableResponsePayload(responseItem);
        const res = await this.$apollo.mutate({
          mutation: DataServices.insertData('available_reponse'),
          variables: {
            objects: list
          }
        });
        responseItem.id = res.data[Object.keys(res.data)]?.returning[0]?.id;
      } else {
        let list = this.buildAvailableResponsePayload(responseItem);
        delete list.available_id;
        delete list.created_at;
        delete list.created_by;
        await this.$apollo.mutate({
          mutation: DataServices.updateData('available_reponse'),
          variables: {
            data_update: list,
            where_key: {
              id: { '_eq': responseItem.id }
            }
          }
        });
      }

      delete responseItem.is_new;
      delete responseItem.is_updated;
      return responseItem;
    },
    buildAvailableResponsePayload(item) {
      let list = {
        available_id: this.model.id,
        status: item.status,
        uid: item?.user?.id,
        owner_id: item?.owner?.id,
        updated_by: item?.updated_by || this.$store.getters.user,
        created_by: item?.created_by || this.$store.getters.user,
        updated_at: item?.updated_at || new Date(),
        created_at: item?.created_at || new Date(),
        total_days: parseInt(item?.total_days || 0),
        total_amount: parseFloat(item?.total_amount || 0),
        cleaning_fee: parseFloat(item?.cleaning_fee || 0),
        other_fee: parseFloat(item?.other_fee || 0),
        service_fee: parseFloat(item?.service_fee || 0),
        net_amount: parseFloat(item?.net_amount || 0)
      };
      if (this.type == 3) {
        if (!this.$commonFuction.isEmpty(item?.arrival) && !this.$commonFuction.isEmpty(item?.departure)) {
          list.arrival = item.arrival;
          list.departure = item.departure;
        }
      }
      return list;
    },
    async persistAvailableRentConfigBeforeAccept() {
      if (parseInt(this.type || 0) !== 3 || !this.model?.id) {
        return;
      }
      await this.$apollo.mutate({
        mutation: DataServices.updateData('available'),
        variables: {
          data_update: {
            deposit: this.deposit,
            price: this.price,
            rent_thirdparty_price: this.rent_thirdparty_price,
            rent_service_fee_rate: this.rent_service_fee_rate,
            rent_cleaning_fee: this.rent_cleaning_fee,
            rent_other_fee: this.rent_other_fee,
            active: this.active,
            is_admin_update_price: this.is_admin_update_price,
            updated_at: moment.tz(new Date(), this.time_zone_local),
            updated_by: this.$store.getters.user
          },
          where_key: {
            id: { '_eq': this.model.id }
          }
        }
      });
    },
    formatResponseMoney(value) {
      return this.$commonFuction.formatLocalCurrency(parseFloat(value || 0));
    },
    closeResponseDialog() {
      this.showPopupAdd = false;
      this.editingResponseIndex = null;
      this.responseDialogMode = 'add';
      this.responseEditStatus = 'ST001';
      this.responseEditCleaningFee = parseFloat(this.rent_cleaning_fee || 0);
      this.responseEditOtherFee = parseFloat(this.rent_other_fee || 0);
      this.selUser = null;
      this.arrival = null;
      this.departure = null;
    },
    parseResponseDateTime(value) {
      if (this.$commonFuction.isEmpty(value)) {
        return null;
      }
      const normalizedValue = `${value}`.replace('T', ' ').replace(/\+\d{2}:\d{2}$/, '').replace('Z', '');
      const matched = normalizedValue.match(/^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2})(?::(\d{2}))?$/);
      if (!matched) {
        return new Date(value);
      }
      const [, year, month, day, hour, minute, second = '00'] = matched;
      return new Date(
        parseInt(year),
        parseInt(month) - 1,
        parseInt(day),
        parseInt(hour),
        parseInt(minute),
        parseInt(second)
      );
    },
    async addResponse() {
      this.responseDialogMode = 'add';
      this.showPopupAdd = true;
      this.editingResponseIndex = null;
      this.responseEditStatus = 'ST001';
      this.responseEditCleaningFee = parseFloat(this.rent_cleaning_fee || 0);
      this.responseEditOtherFee = parseFloat(this.rent_other_fee || 0);
      this.selUser = null;
      if(this.type==3){
        //this.week_name = `Week ${this.model.visit.week_number} (${this.getFilterDate(this.model.visit.visit_start)} - ${this.getFilterDate(this.model.visit.visit_end)})`
       //FORMAT_DATE_SEVER
       this.$constants.FORMAT_DATE_SEVER
       var visit_start =  moment.utc(this.model.visit.visit_start).format(this.$constants.FORMAT_DATE_SEVER);
      // var visit_end =  moment.utc(this.model.visit.visit_end).format(this.$constants.FORMAT_DATE_SEVER);
       var visit_end = moment.utc(this.model.visit.visit_end).add(1, 'days').format(this.$constants.FORMAT_DATE_SEVER);
        this.arrival = new Date(`${visit_start} 15:00:00`);
        this.departure = new Date(`${visit_end} 10:00:00`);
      }
    },
    editResponse(index) {
      const selectedResponse = this.$commonFuction.convertJsonObject(this.response[index]);
      this.responseDialogMode = 'edit';
      this.editingResponseIndex = index;
      this.showPopupAdd = true;
      this.selUser = selectedResponse.user || null;
      this.arrival = this.parseResponseDateTime(selectedResponse.arrival);
      this.departure = this.parseResponseDateTime(selectedResponse.departure);
      this.responseEditStatus = selectedResponse.status || 'ST001';
      this.responseEditCleaningFee = parseFloat(selectedResponse.cleaning_fee ?? this.rent_cleaning_fee ?? 0);
      this.responseEditOtherFee = parseFloat(selectedResponse.other_fee ?? this.rent_other_fee ?? 0);
    },
    async confirmPopupAdd() {
      let choose_user_add = document.getElementById("choose_user");
      if (this.$commonFuction.isEmptyObject(this.selUser)){
        alert("Please choose user/renter!");
        return;
        //choose_user_add.setCustomValidity("Please choose user/renter!");
      }else {
        let checkRes = this.response.filter((f, index) => f?.user?.id == this.selUser?.id && index !== this.editingResponseIndex);
        if (checkRes.length > 0) {
          choose_user_add.setCustomValidity("This user/renter already exists in the list");
          alert("This user/renter already exists in the list");
          return;
        } 
        // else {
        //   choose_user_add.setCustomValidity("");
        // }
      }
      if (this.$commonFuction.isEmpty(this.arrival)){
        alert("Please choose arrival time!");
        return;
      }
      if (this.$commonFuction.isEmpty(this.departure)){
        alert("Please choose departure time!");
        return;
      }
      var arrival_check =moment(this.arrival).format("YYYYMMDDHHmm");
      var departure_check =moment(this.departure).format("YYYYMMDDHHmm");
      if (parseInt(arrival_check) > parseInt(departure_check)){
        alert("Arrival time must be less than departure time!");
        return;
      }
      // var inpObj = document.getElementById("frm_action_add");
      // if (!inpObj.checkValidity()){
      //   inpObj.reportValidity();
      //   return true;
      // }
      console.log("this.response", this.response);
      //+00:00
      var dataRes = {
        user: this.selUser,
        is_new: this.responseDialogMode === 'add',
        status: this.responseEditStatus,
        cleaning_fee: parseFloat(this.responseEditCleaningFee || 0),
        other_fee: parseFloat(this.responseEditOtherFee || 0),
        created_at: new Date(),
        updated_at: new Date(),
        updated_by: this.$store.getters.user
      }
      if(this.type==3){
        console.log("this.arrival", this.arrival);
         dataRes.arrival = moment(this.arrival).format("YYYY-MM-DD HH:mm:ss+00:00");
          console.log("this.arrival", dataRes.arrival);
         dataRes.departure = moment(this.departure).format("YYYY-MM-DD HH:mm:ss+00:00");
        // dataRes.arrival = moment(this.arrival).format("YYYY-MM-DD HH:mm:ss+00:00");
        // dataRes.departure = moment(this.departure).format("YYYY-MM-DD HH:mm:ss+00:00");
      //console
        // dataRes.arrival = this.arrival
        // dataRes.departure = this.departure
      }
      Object.assign(dataRes, this.buildResponseFinancials(dataRes));
      if (this.responseDialogMode === 'edit' && this.editingResponseIndex !== null) {
        const currentResponse = this.response[this.editingResponseIndex];
        dataRes.id = currentResponse?.id;
        dataRes.created_at = currentResponse?.created_at || dataRes.created_at;
        dataRes.created_by = currentResponse?.created_by || currentResponse?.user?.id;
        dataRes.update_user = this.$store.getters.user;
        if (!currentResponse?.is_new) {
          dataRes.is_updated = true;
        }
        const updatedResponse = {
          ...currentResponse,
          ...dataRes
        };
        updatedResponse.status = this.responseEditStatus;
        this.$set(this.response, this.editingResponseIndex, updatedResponse);
      } else {
        this.response.push(dataRes)
      }
      this.convertDataResponse();
      this.response = [...this.response];
      this.syncAvailableStatusFromResponses();
      this.updateDatatable++;
      const targetResponse = this.responseDialogMode === 'edit' && this.editingResponseIndex !== null
        ? this.response[this.editingResponseIndex]
        : this.response[this.response.length - 1];
      await this.persistResponseImmediately(targetResponse);
      this.closeResponseDialog();
    },
    cancelAvailable() {
      this.popupCancelAvailable = true;
    },
    async confirmCancelAvailable() {
      // let variables = {
      //   'data_update': {
      //     'status': "ST003"
      //   },
      //   'where_key': {
      //     'id': {'_eq': this.model.id}
      //   }
      // };
      // this.$apollo.mutate({
      //   mutation: DataServices.updateData('available'),
      //   variables: variables
      // }).then(() => {
      //   this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Cancel request successfully', life: 3000 })
      // })
      
      const headers = {
        "Authorization": "Bearer "+(await this.$AuthenticationApp.getToken()),
      };
      var dataUpd = {
        available_id: this.model.id
      }
      var url = '_api/property/cancel_available_admin';
      ApiRepository.post(url, dataUpd, {headers}).then(() => {
        setTimeout(() => {
          this.$emit('loadData');
          this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Cancel request successfully', life: 3000 })
        }, 200);
      })
      this.popupCancelAvailable = false;
      // this.$emit("loadData");
    },
    showPopupAccept(index, type) {
      this.response[index].type = type;
      this.dataConfirmAccept = this.response[index];
      this.popupConfirmAccept = true;
    },
    async acceptResponse() {
      this.syncRentResponseFinancials();
      if (this.dataConfirmAccept?.id) {
        const latestResponse = (this.response || []).find(item => item?.id === this.dataConfirmAccept.id);
        if (latestResponse) {
          this.dataConfirmAccept = Object.assign(this.dataConfirmAccept, latestResponse);
        }
      }
      await this.persistAvailableRentConfigBeforeAccept();
      if (this.dataConfirmAccept?.is_new) {
        let list = this.buildAvailableResponsePayload(this.dataConfirmAccept);
        await this.$apollo.mutate({
            mutation: DataServices.insertData('available_reponse'),
            variables: {
              objects: list
            }
        }).then(async (res) => {
          this.dataConfirmAccept.id = await res.data[Object.keys(res.data)]?.returning[0]?.id;
        })
        delete this.dataConfirmAccept.is_new;
      } else if (this.dataConfirmAccept?.id) {
        let list = this.buildAvailableResponsePayload(this.dataConfirmAccept);
        delete list.available_id;
        delete list.created_at;
        delete list.created_by;
        await this.$apollo.mutate({
          mutation: DataServices.updateData('available_reponse'),
          variables: {
            data_update: list,
            where_key: {
              id: { '_eq': this.dataConfirmAccept.id }
            }
          }
        });
      }
      const headers = {
        "Authorization": "Bearer "+(await this.$AuthenticationApp.getToken()),
      };
      var dataUpd = {
        available_response_id: this.dataConfirmAccept.id
      }
      var url = this.dataConfirmAccept.type == 'exchange' ? '_api/property/accept_response_exchange_admin' : '_api/property/accept_response_rent_admin';
      ApiRepository.post(url, dataUpd, {headers}).then(() => {
        setTimeout(() => {
          this.$emit('loadData');
        }, 200);
      })
      this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Accept request successfully', life: 3000 })
      this.popupConfirmAccept = false;
      this.dataConfirmAccept = null;
    },
    async sendResponseEmail(index) {
      const targetResponse = this.response[index];
      if (!targetResponse?.id) {
        this.$toast.add({ severity: 'warn', summary: 'Warning', detail: 'Please save response before sending email', life: 3000 });
        return;
      }
      const headers = {
        "Authorization": "Bearer "+(await this.$AuthenticationApp.getToken()),
      };
      try {
        await ApiRepository.post('_api/property/send_email_response_rent_admin', {
          available_response_id: targetResponse.id
        }, { headers });
        this.$set(this.response[index], 'is_send_email', true);
        this.response = [...this.response];
        this.updateDatatable++;
        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Send email successfully', life: 3000 });
        setTimeout(() => {
          this.$emit('loadData');
        }, 200);
      } catch (error) {
        const detail = error?.response?.data?.message || error?.response?.data?.msg || 'Send email failed';
        this.$toast.add({ severity: 'error', summary: 'Error', detail, life: 3000 });
      }
    },
    async cancelResponse(index) {
      // this.response[index].status = "ST001";
      // let variables = {
      //   'data_update': {
      //     'status': this.response[index].status
      //   },
      //   'where_key': {
      //     'id': {'_eq': this.response[index]?.id}
      //   }
      // };
      // await this.$apollo.mutate({
      //   mutation: DataServices.updateData('available_reponse'),
      //   variables: variables
      // })
      
      // let variables_ = {
      //   'data_update': {
      //     'status': "ST001"
      //   },
      //   'where_key': {
      //     'id': {'_eq': this.model.id}
      //   }
      // };
      // await this.$apollo.mutate({
      //   mutation: DataServices.updateData('available'),
      //   variables: variables_
      // }).then(() => {
      //   setTimeout(() => {
      //     this.$emit('loadData');
      //   }, 200);
      // });
      const headers = {
        "Authorization": "Bearer "+(await this.$AuthenticationApp.getToken()),
      };
      var dataUpd = {
        available_response_id: this.response[index]?.id
      }
      var url = '_api/property/cancel_response_admin';
      ApiRepository.post(url, dataUpd, {headers}).then(() => {
        setTimeout(() => {
          this.$emit('loadData');
          this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Cancel response successfully', life: 3000 })
        }, 200);
      })
    },
    removeChip(index) {
      this.selWeek.splice(index, 1);
    },
    async getListWeek() {
      let startDate = moment().startOf('month');
      let endDate = moment(moment().startOf('month').add(1, "years").endOf('month'));
      let diff_date = endDate.diff(startDate, 'days');
      console.log("startDate", startDate);
      console.log("endDate", endDate);
      console.log("diff_date", diff_date);
      this.listWeek = [];
      let days = 7;
      this.listWeek.push({visit_start: moment(moment(startDate).startOf('week').format('YYYY/MM/DD HH:mm:ss')), visit_end: moment(moment(startDate).endOf('week').format('YYYY/MM/DD HH:mm:ss'))});
      for(let i=1; i <= diff_date; i++) {
        if(i%days==0 && i != diff_date) {
          let start_d = moment(moment(startDate).add((i+1), 'days').startOf('week').format('YYYY/MM/DD HH:mm:ss'));
          this.listWeek.push({visit_start: start_d, visit_end: moment(moment(start_d).endOf('week').format('YYYY/MM/DD HH:mm:ss'))});
        }
      }
    },
    async getListUser() {
      var where_key = {
        role: {_in: ['owner', 'renter']},
        deleted: {_eq: false}
      }
      let {data} = await this.$apollo.query({
        query: DataServices.getList('users',{"fields" : `id fullname role email arr_part{id obj_property{id name}}`}),
        variables: {
          where_key: where_key,
          orderBy:[{created_at : 'desc'}]
        },
        fetchPolicy: "network-only"
      })
      var list = data[Object.keys(data)];
      var list_owner = [];
      for (let i = 0; i < list.length; i++) {
        const e = list[i];
        list_owner.push({id : e.id, fullname :e.fullname, email: e.email, arr_part: e.arr_part, role: e.role});
      }
      this.listUser = list_owner;
      this.listUserAll = list_owner;
    },
    filterUser(option) {
      if (typeof option === 'object') {
        return this.getLabelListUser(option);
      }
      return option;
    },
    async searchListUser(search, loading){
      loading(true);
      if(search !== '' && search !== null){
        var where_key = {
          deleted: {_eq: false},
          role: {_in: ['owner', 'renter']},
          _or: [{
            fullname:{_iregex: this.$commonFuction.search(search)}
          },{
            arr_part: {obj_property: {name:{_iregex: this.$commonFuction.search(search)}}}
          },{
            email:{_iregex: this.$commonFuction.search(search)}
          }]
        }
        let {data} = await this.$apollo.query({
          query: DataServices.getList('users',{"fields" : `id fullname email role arr_part{id obj_property{id name}}`}),
          variables: {
            where_key: where_key,
            orderBy:[{created_at : 'desc'}]
          },
          fetchPolicy: "network-only"
        })
        var list = data[Object.keys(data)];
        var list_owner = [];
        for (let i = 0; i < list.length; i++) {
          const e = list[i];
          list_owner.push({id : e.id, fullname :e.fullname, email: e.email, arr_part: e.arr_part, role: e.role});
        }
        this.listUser = list_owner;
        loading(false);
      }else{
        this.listUser = this.listUserAll;
        loading(false);
      }
      return this.listUser;
    },
    async getListOwnerProperty() {
      var where_key = {
        property_id: {_eq: this.property_id}, 
      }
      if (this.uid) {
        where_key.uid = {_neq: this.uid}
      }
      let {data} = await this.$apollo.query({
        query: DataServices.getList('property_part',{"fields" : `id user {id fullname email}`}),
        variables: {
          where_key: where_key,
          orderBy:[{order_booking : 'desc'}]
        },
        fetchPolicy: "network-only"
      })
      var list = data[Object.keys(data)];
      var list_owner = [];
      var checkUser = [];
      for (let i = 0; i < list.length; i++) {
        const e = list[i];
        if(!checkUser.includes(e.user.id)) {
          list_owner.push({id : e.user.id, fullname :e.user.fullname, email: e.user.email});
          checkUser.push(e.user.id);
        }
      }
      this.listOwnerProperty = list_owner;
      this.listOwnerPropertyAll = list_owner;
    },
    async SearchOwnerProperty(search, loading){
      console.log(loading);
      if(search !== '' && search !== null){
        var where_key = {
          property_id: {_eq: this.property_id},
          _or: {
            user:{fullname:{_iregex: this.$commonFuction.search(search)}},
          }
        }
        if (this.uid) {
          where_key.uid = {_neq: this.uid}
        }
        let {data} = await this.$apollo.query({
          query: DataServices.getList('property_part',{"fields" : `id user {id fullname email}`}),
          variables: {
            where_key: where_key,
            orderBy:[{order_booking : 'desc'}]
          },
          fetchPolicy: "network-only"
        })
        var list = data[Object.keys(data)];
        var list_owner = [];
        var checkUser = [];
        for (let i = 0; i < list.length; i++) {
          const e = list[i];
          if(!checkUser.includes(e.user.id)) {
            list_owner.push({id : e.user.id, fullname :e.user.fullname, email: e.user.email});
            checkUser.push(e.user.id);
          }
        }
        this.listOwnerProperty = list_owner;
      }else{
        this.listOwnerProperty = this.listOwnerPropertyAll;
      }
    },
    removeProduct(index) {
      this.products.splice(index, 1);
    },
    addProduct() {
      this.products.push({
        product: {price: 0},
        price: 0,
        qty: 0
      })
    },
    getWeekDate(date) {
      if (!this.$commonFuction.isEmpty(date)){
        return moment(date).isoWeek();
          }else{
        return "";
      }
    },
    getFilterDate(date) {
      if (!this.$commonFuction.isEmpty(date)){
      return moment.tz(date, this.time_zone_local).format("ll");
       }else{
        return "";
      }
    },
    getFilterDateTime(date) {
       if (!this.$commonFuction.isEmpty(date)){
      return moment.tz(date, this.time_zone_local).format("LL HH:mm:ss");
       }else{
        return "";
      }
    },
    getFilterDateTimeNotTimeZone(date) {
      if (!this.$commonFuction.isEmpty(date)){
        
      return moment.tz(date, "UTC").format("LL HH:mm:ss");
      }else{
        return "";
      }
    },
    backToList() {
      this.$emit('back');
    },
    async validateData() {
      this.validationErrors = {};
      let status_add = document.getElementById("status");
      if (this.$commonFuction.isEmptyObject(this.selStatus)){
        status_add.setCustomValidity("Please choose status!");
      }else {
        status_add.setCustomValidity("");
      }
      if (this.type == 2) {
        let list_rule_add = document.getElementById("rule_arr");
        if (this.listRuleExchange.length < 1){
          list_rule_add.setCustomValidity("Please add at least one exchange option!");
        }else {
          list_rule_add.setCustomValidity("");
        }
        let contact_name_add = document.getElementById("contact_name");
        if (!this.contact_name){
          contact_name_add.setCustomValidity("Please input contact name!");
        }else {
          contact_name_add.setCustomValidity("");
        }
        
        let contact_phone_add = document.getElementById("contact_phone");
        if (!this.contact_phone){
          contact_phone_add.setCustomValidity("Please input phone number!");
        }else {
          contact_phone_add.setCustomValidity("");
        }
      } else if (this.type == 3) {
        let price_add = document.getElementById("price");
        var rent_thirdparty_price_add = document.getElementById("rent_thirdparty_price");
        let deposit_add = document.getElementById("deposit");
        let rent_service_fee_rate_add = document.getElementById("rent_service_fee_rate");
        var key_value_status = this.selStatus?.value ?? '';
        if(key_value_status != 'ST003'){
          if (!this.price || this.price <= 0){
            price_add.setCustomValidity("Please input price per day!");
          }else {
            price_add.setCustomValidity("");
          }
          if (!this.rent_thirdparty_price || this.rent_thirdparty_price <= 0){
            rent_thirdparty_price_add.setCustomValidity("Please input rent thirdparty price!");
          }else {
            rent_thirdparty_price_add.setCustomValidity("");
          }
          if (this.rent_service_fee_rate > 100){
            rent_service_fee_rate_add.setCustomValidity("Service fee rate cannot be greater than 100%!");
          }else {
            rent_service_fee_rate_add.setCustomValidity("");
          }
          deposit_add.setCustomValidity("");
        }
      }

      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()){
        inpObj.reportValidity();
        return true;
      }
    },

    async saveData() {
      if (this.isCancelledStatus) {
        return;
      }
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return
      }
      this.syncRentResponseFinancials();
      var params = {
        note: this.note,
        contact_name: this.contact_name,
        contact_phone: this.contact_phone,
        is_admin_update_price: this.is_admin_update_price,
        response: this.$commonFuction.convertJsonObject(this.response),
        deposit: this.deposit,
        price: this.price,
        rent_thirdparty_price: this.rent_thirdparty_price,
        rent_service_fee_rate: this.rent_service_fee_rate,
        rent_cleaning_fee: this.rent_cleaning_fee,
        rent_other_fee: this.rent_other_fee,
        active: this.active,
        owner_id: this.selOwnerProperty?.id,
        my_property: this.my_property,
        status: this.selStatus?.value,
        list_week: this.selWeek,
        list_rule_exchange: this.listRuleExchange,
        type: this.type,
        old_status: this.old_status,
      }
      console.log('saveData', params)
      this.$emit('save', params)
    },
  },
}
</script>

<style lang="scss">
.p-multiselect {
  width: 450px;
}
.p-multiselect-label:not(.p-placeholder) {
  padding-top: .25rem;
  padding-bottom: .25rem;

}
.category-item-value {
  padding: .25rem .5rem;
  border-radius: 3px;
  display: inline-flex;
  margin-right: .2rem;
  background-color: var(--primary-color);
  color: var(--primary-color-text);
}
.p-multiselect-label-container{
  height: 40px;
}
.p-inputtext{
  margin:  0px 0px 0px 4px;
}

//style form add-edit
@media screen and (min-width: 1001px) {
  .input_distance {
    width: 728px !important;
  }
}
label.p-col-fixed txt-right{
  margin-bottom: 0px!important;
}
div.p-card-field{
  padding: 0px!important;
}
.p-col-fixed {
  padding: 0px !important;
  margin:0px 0px 0px 9px !important;
}
.input_text{
  width: 760px!important;
  height: 48px!important;
}
.txt-right{
  font-weight: bold;
}

.multiselect{
  width: 760px!important;
}
.layout-main{
  background: #00000029;
}

.vs__clear{
  display: none;
}
.input_width{
  width: 760px!important;
  height: 48px!important;
}
#distance{
  width: 1px!important;
  height: 48px!important;
  border-left: 0px;
  border-top: 0px;
  border: 1px solid #C8C8C8;
  border-radius: 0px;
  //border-top: none!important;
  //border: 1px solid rgba(60, 60, 60, 0.26);;
}
.manager-title{
  font-size: 24px!important;
}
.input-dif{
  margin-left: 5px!important;
  border-top: 0px;
}
.p-inputgroup-addon{
  height: 48px ;
}
.txt-right{
  font-weight: bold;
}
.p-col-fixed {
  padding: 0px !important;
  //margin:0px 0px 0px 10px !important;
}
label.p-col-fixed txt-right{
  margin-bottom: 0px!important;
}
div.p-card-field{
  padding: 0px!important;
}
.margin{
  margin-bottom: 12px!important;
}

.border_color{
  border: 1px solid #C8C8C8;
}
.text{
  font-weight: normal!important;
  margin-left: 15px!important;
}
.div_check{
  margin-top: 12px!important;
}

.rent-config-grid{
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.5rem;
  margin-bottom: 1rem;
  width: calc(200% + 1.5rem);
  max-width: none;
}

.rent-config-column .p-card-field{
  margin-bottom: 1rem;
}

.rent-config-column .p-col{
  width: 100%;
}

.rent-config-column .p-inputgroup,
.rent-config-column .p-inputnumber,
.rent-config-column .p-inputnumber input{
  width: 100%;
}


//responsive
@media screen and (max-width: 600px) {
  .input_width{
    width: 100%!important;
  }
  .div-button{
    padding: 8px!important;
  }
  #distance{
    text-align: left!important;
    padding: 6.8px;
    width: 100%!important;
  }
  .p-inputgroup-addon{
    margin-right: 12px;
  }

  .rent-config-grid{
    grid-template-columns: 1fr;
    gap: 0;
    width: 100%;
  }

}

@media screen and (max-width: 1000px) {
  .input_width{
    width: 100%!important;
  }
  .div-button{
    padding: 8px!important;
  }
  .p-inputgroup-addon{
    margin-right: 12px;
  }

  .rent-config-grid{
    grid-template-columns: 1fr;
    gap: 0;
    width: 100%;
  }
  #distance{
    text-align: left!important;
    padding: 6.8px;
  }
}
.p-button-outlined {
  .p-button-label {
    color: #007ad9 !important;
  }
}
.available-top-toolbar {
  position: absolute;
  top: -15px;
  right: 0;
  border-top: none !important;
  margin-top: 0 !important;
  margin-right: 15px;
}
.available-top-toolbar .p-toolbar-group-right {
  align-items: center;
}
@media screen and (min-width: 1001px) {
  .week-expand-zone {
    overflow: visible;
  }
  .week-chip-list {
    width: calc(200% + 8px);
    max-width: none;
  }
}
.available-from .vs--multiple .vs__selected-options {
  .vs__selected {
    display: none;
  }
}
.chip-box {
  background-color:#F2F3F7;
  color: #000;
  border-radius: 10px;
  padding: 10px;
  font-size: 16px;
  width: fit-content;
  font-weight: bold;
  margin-left: 0 !important;
  .clear {
    cursor: pointer;
    color: #666666;
    margin-left: 10px;
    .pi-times:before {
      font-weight: bold;
      font-size: 12px;
    }
  }
}
.vs__selected.txt-ellipsis {
  text-overflow: ellipsis;
  overflow: hidden;
  width: 650px;
  white-space: nowrap;
}
.style-box-phone{
  border: 1px solid #a6a6a6;
  width: 100%;
  display: flex;
  border-radius: 3px;
  .p-dropdown{
    width: 100px;
    border: 0px;
    box-shadow: none !important;
  }
  .p-focus{
    border: 0px;
    box-shadow: none ;
  }
  .p-dropdown:focus{
    border: 0px;
    box-shadow: none;
  }
  input{
    width: calc(100% - 100px);
    margin-left: 0px;
    border: 0px;
  }
  .p-inputtext:enabled:focus {
    border: 0px;
    box-shadow: none;
  }
}

.fee-rules-box {
  background: #fffbe8;
  border: 1px solid #f0e8b2;
  padding: 16px 18px;
  margin-bottom: 14px;
}

.fee-rules-title {
  font-weight: 700;
  margin-bottom: 10px;
}

.fee-rules-list {
  display: grid;
  gap: 8px;
  font-size: 13px;
}

.rent-response-table-wrap {
  overflow-x: auto;
}

.rent-response-table .p-datatable-table {
  min-width: 1600px;
}

.rent-response-table .p-datatable-thead > tr > th {
  white-space: normal !important;
  word-break: keep-all;
  overflow-wrap: break-word;
  vertical-align: middle;
  line-height: 1.35;
}

.response-action-button {
  margin-right: 6px;
  width: 28px;
  height: 28px;
  padding: 0 !important;
  border-radius: 2px !important;
}

.response-action-button .p-button-icon {
  font-size: 0.85rem;
}

.response-action-button-accept {
  background: #4090e8 !important;
  border: 1px solid #4090e8 !important;
  color: #ffffff !important;
}

.response-action-button-cancel {
  background: #e85b5b !important;
  border: 1px solid #e85b5b !important;
  color: #ffffff !important;
}

.response-send-email-button {
  height: 30px !important;
  padding: 0 12px !important;
  margin-right: 6px;
  width: auto !important;
  min-width: 84px;
  border-radius: 999px !important;
  background: linear-gradient(135deg, #4a93ef 0%, #2f6fd6 100%) !important;
  border: 1px solid #2f6fd6 !important;
  box-shadow: 0 6px 14px rgba(47, 111, 214, 0.18);
  color: #ffffff !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  display: inline-flex !important;
  justify-content: center;
  align-items: center;
  flex: 0 0 auto !important;
}

.response-send-email-button .p-button-icon {
  font-size: 0.8rem;
  margin-right: 6px;
}

.response-email-sent-label {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 70px;
  height: 30px;
  padding: 0 12px;
  margin-right: 6px;
  border-radius: 999px;
  background: #eef7f1;
  border: 1px solid #b7dec3;
  color: #25834d;
  font-size: 12px;
  font-weight: 600;
}

.response-email-sent-icon {
  font-size: 0.8rem;
}

.response-dialog.p-dialog {
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 16px 40px rgba(22, 34, 51, 0.18);
  max-height: 88vh;
}

.response-dialog .p-dialog-header {
  background: #ffffff;
  border-bottom: 1px solid #edf0f4;
  padding: 1rem 1.25rem;
  border-top-left-radius: 14px;
  border-top-right-radius: 14px;
}

.response-dialog .p-dialog-content {
  padding: 0;
  background: #ffffff;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  max-height: calc(88vh - 126px);
}

.response-dialog .p-dialog-footer {
  border-top: 1px solid #edf0f4;
  padding: 1rem 1.25rem;
  background: #ffffff;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.response-dialog-body {
  padding: 1.35rem 1.25rem 0.75rem;
  max-height: none;
  overflow: visible;
}

.response-dialog-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.response-dialog-grid-secondary {
  margin-top: 12px;
}

.response-dialog-field,
.response-dialog-status {
  margin-bottom: 14px;
}

.response-dialog-label {
  display: block;
  font-weight: 600;
  color: #334155;
  margin-bottom: 8px;
}

.response-dialog-control {
  padding: 0;
}

.response-dialog-control .p-calendar,
.response-dialog-control .p-inputtext,
.response-dialog-control .p-dropdown,
.response-dialog-control .vs--disabled,
.response-dialog-control .v-select,
.response-dialog-control .p-inputwrapper,
.response-dialog-control .p-inputnumber {
  width: 100%;
}

.response-dialog-control .p-inputtext,
.response-dialog-control .p-dropdown,
.response-dialog-control .vs__dropdown-toggle,
.response-dialog-control .p-calendar .p-inputtext {
  min-height: 42px;
  border-radius: 8px;
  border-color: #d8dee8;
  box-shadow: none;
  margin-left: 0;
}

.response-user-select .vs__dropdown-toggle,
.response-user-select .vs__selected-options,
.response-user-select .vs__selected {
  max-width: 100%;
}

.response-user-select .vs__selected,
.response-user-select .vs__selected-options,
.response-user-select .vs__search,
.response-user-select .txt-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.response-dialog-control .p-calendar .p-datepicker-trigger {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}

.response-dialog-control .p-inputtext[disabled] {
  background: #f4f5f8;
  color: #495057;
  border-color: #e4e8ef;
}

.response-dialog-cancel.p-button {
  background: #ffffff !important;
  border: 1px solid #d6dce5 !important;
  color: #2f80d1 !important;
}

.response-dialog-cancel.p-button .p-button-label,
.response-dialog-cancel.p-button .p-button-icon {
  color: #2f80d1 !important;
}

.response-dialog-submit.p-button {
  background: #2f80d1;
  border-color: #2f80d1;
}

body .p-datepicker,
body .p-component-overlay,
body .p-datepicker-panel {
  z-index: 100000 !important;
}

.response-dialog .response-calendar-panel.p-datepicker {
  z-index: 100001 !important;
}

.exchange-option-dialog .p-dialog-content {
  padding-bottom: 1rem;
}
.exchange-option-dialog .week-chip-list {
  width: 100% !important;
  max-width: 100% !important;
  overflow: hidden;
}
.exchange-option-dialog .chip-box {
  max-width: 100%;
  width: auto;
  margin: 6px 6px 0 0 !important;
  font-size: 14px;
  line-height: 1.35;
}
.exchange-option-dialog .chip-box > span:first-child {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.exchange-rule-radio-group {
  display: flex;
  flex-wrap: wrap;
  gap: 16px 28px;
  padding: 8px 0 4px;
}

.exchange-rule-radio-item {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.exchange-rule-radio-item label {
  margin: 0;
  font-weight: 600;
}

.property-option-row {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.property-option-title {
  font-weight: 600;
}

.property-option-address {
  font-size: 12px;
  color: #6b7280;
}

.option-property-chip-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.option-property-chip {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  padding: 4px 10px;
  border-radius: 999px;
  border: 1px solid #d9e6f7;
  background: #f5f9ff;
  color: #2f4f77;
  font-size: 12px;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media screen and (max-width: 768px) {
  .response-dialog-grid {
    grid-template-columns: 1fr;
  }
}

/* Keep disabled Active checkbox readable on cancelled status */
.active-status-checkbox.p-disabled {
  opacity: 1 !important;
}

.active-status-checkbox.p-disabled .p-checkbox-box {
  border-color: #9aa7b6 !important;
  background: #f5f7fa !important;
}

.active-status-checkbox.p-disabled .p-checkbox-box.p-highlight {
  background: #2196f3 !important;
  border-color: #2196f3 !important;
}

.active-status-checkbox.p-disabled .p-checkbox-box .p-checkbox-icon {
  color: #ffffff !important;
}
</style>
